// @flow

import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from '../../../../context/LanguageContext';
import { Table, TableBody, TableRow, TableCell, TableHead, Typography } from '@mui/material';

const ToleranceInfoDialog = ({ open, onClose }) => {
  const tolerantCrops: string[] = ['rye', 'grass', 'oat', 'potatoe'];
  const middleCrops: string[] = [
    'wheat',
    'trticale',
    'corn',
    'redClover',
    'whiteCloverLupin',
    'turnip',
  ];
  const sesitiveCrops: string[] = ['snailPods', 'lucerne', 'beets', 'pea', 'barley', 'rapeseed'];
  const LangFile = useLangFile();
  return (
    <Fragment>
      <Dialog open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle>
          {LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog.title}
        </DialogTitle>

        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              mb: 1,
            }}
          >
            {' '}
            <Typography variant="subtitle1">
              {LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog.message}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {LangFile.PrescriptionSettings.limeInfo.tolerance.options.tolerant}
                  </TableCell>
                  <TableCell>
                    {LangFile.PrescriptionSettings.limeInfo.tolerance.options.middle}
                  </TableCell>
                  <TableCell>
                    {LangFile.PrescriptionSettings.limeInfo.tolerance.options.sensitive}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell>
                    {tolerantCrops.map((tc) => (
                      <Typography key={tc} variant="body1">
                        {
                          LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog.tolerantCrops[
                            tc
                          ]
                        }
                      </Typography>
                    ))}
                  </TableCell>
                  <TableCell>
                    {middleCrops.map((mc) => (
                      <Typography key={mc} variant="body1">
                        {
                          LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog.middleCrops[
                            mc
                          ]
                        }
                      </Typography>
                    ))}
                  </TableCell>
                  <TableCell>
                    {sesitiveCrops.map((sc) => (
                      <Typography key={sc} variant="body1">
                        {
                          LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog
                            .sensitiveCrops[sc]
                        }
                      </Typography>
                    ))}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color={'inherit'} variant={'outlined'}>
            {LangFile.PrescriptionSettings.limeInfo.tolerance.infoDialog.close}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(ToleranceInfoDialog);

ToleranceInfoDialog.propTypes = {
  open: PropTypes.bool,
};
